module.exports = __webpack_public_path__ + "img/DISS.251c4c3c.svg";